/* assets/rfbundle.js */
(function () {
  var bundle = document.getElementById('rf-bundle');
  if (!bundle) return;

  var options = bundle.querySelectorAll('.rf-option');
  var currentQty = 1;

  var nativeValueSetter = Object.getOwnPropertyDescriptor(
    window.HTMLInputElement.prototype, 'value'
  ).set;

  function applyQty(qtyInput, qty) {
    nativeValueSetter.call(qtyInput, qty);
    qtyInput.setAttribute('value', qty);
    qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function findQtyInputs() {
    // Tu tema no trae un campo de cantidad en el formulario de "Agregar al
    // carrito" (lo confirmamos por consola: no existe ningún
    // input[name="quantity"]), así que lo creamos nosotros y lo insertamos
    // en CADA formulario que agregue al carrito (el principal y, si existe,
    // el de la barra fija / sticky add to cart).
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    var inputs = [];
    forms.forEach(function (form) {
      var input = form.querySelector('input[name="quantity"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'quantity';
        input.value = '1';
        form.appendChild(input);
      }
      inputs.push(input);
    });
    return inputs;
  }

  function setQuantity(qty) {
    currentQty = qty;
    findQtyInputs().forEach(function (qtyInput) {
      applyQty(qtyInput, qty);
    });
  }

  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    findQtyInputs().forEach(function (qtyInput) {
      applyQty(qtyInput, currentQty);
    });
  }, true);

  function selectOption(opt) {
    options.forEach(function (o) {
      o.classList.remove('is-selected');
    });
    opt.classList.add('is-selected');

    var radio = opt.querySelector('input[type="radio"]');
    if (radio) radio.checked = true;
    var qty = parseInt(opt.getAttribute('data-qty'), 10) || 1;
    setQuantity(qty);
  }

  options.forEach(function (opt) {
    opt.addEventListener('click', function () {
      selectOption(opt);
    });
  });

  var initial = bundle.querySelector('.rf-option.is-selected') || options[0];
  if (initial) selectOption(initial);
})();